var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-download';
                    var viewUrl = 'sprite.svg#view-icon-download';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-download#icon-download';
                            viewUrl = 'sprite.svg?icon-download#view-icon-download';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 20 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };